<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">

        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
            <div class="flex-header">
                <student-header [showYearSelector]="false" [pageTitle]="'Student Portfolio'"></student-header>
            </div>

            <div class="flex-content">
                <div *ngIf="studentPortfolios && studentPortfolios.length == 0" style="text-align:center;">
                    <span translate>No Student Portfolio data exists for this student.</span>
                </div>

                <div id="divPortfolioGrid" *ngIf="studentPortfolios && studentPortfolios.length > 0">
                    <mat-table #table [dataSource]="portfolioSource" matSortDisableClear matSort
                        aria-label="Portfolio Table" tabindex="0" matSortActive="Added" matSortDirection="desc">

                        <ng-container matColumnDef="Added">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Added" style="display: flex; flex: .5">
                                <span translate>Added</span>
                                <filter [data]="portfolioSource" columnName="Added" dataType="date" id="dateFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: .5">
                                {{getDateFormatted(portfolio.Added)}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Category">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Category"
                                             style="display: flex; flex: .8">
                                <span translate>Category</span>
                                <filter [data]="portfolioSource" columnName="Category" dataType="string" id="categoryFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: .8">
                                {{portfolio.Category}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Description">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Description"
                                             style="display: flex; flex: 1">
                                <span translate>Description</span>
                                <filter [data]="portfolioSource" columnName="Description" dataType="string" id="descFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: 1">
                                {{portfolio.Description}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="FileName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Name"
                                             style="display: flex; flex: 2">
                                <span translate>File Name</span>
                                <filter [data]="portfolioSource" columnName="Name" dataType="string" id="nameFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: 2">
                                <a (click)="viewPortfolio(portfolio)"
                                    style="cursor:pointer; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                    {{portfolio.Name}}
                                </a>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Size">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="Size"
                                             style="display: flex; flex: .5">
                                <span translate>Size</span>
                                <filter [data]="portfolioSource" columnName="Size" dataType="string" id="sizeFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: .5">
                                {{round(portfolio.Size)}}&nbsp;{{portfolio.SizeUnit}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Year">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="AYIdentifier"
                                             style="display: flex; flex: .5">
                                <span translate>Year</span>
                                <filter [data]="portfolioSource" columnName="AYIdentifier" dataType="string" id="yearFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: .5">
                                {{portfolio.AYIdentifier}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="AddBy">
                            <mat-header-cell *matHeaderCellDef mat-sort-header="AddedBy"
                                             style="display: flex; flex: .8">
                                <span translate>Added By</span>
                                <filter [data]="portfolioSource" columnName="AddedBy" dataType="string" id="addByFilter"
                                    class="mat-filter"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let portfolio" style="display: flex; flex: .8">
                                {{portfolio.AddedBy}}
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="RecentAccessHistory">
                            <mat-header-cell *matHeaderCellDef mat-sort-header style="display: flex; flex: 1">
                                <span translate>Access History</span>
                                <filter [data]="portfolioSource" columnName="RecentAccessHistory" dataType="string"></filter>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let SD" style="display: flex; flex: 1">
                                <a *ngIf="SD.RecentAccessHistory.length > 0" class="link" (click)="studentAccessHistoryClick(SD)">
                                    {{SD.RecentAccessHistory[0].LastName}}, {{SD.RecentAccessHistory[0].FirstName}} {{SD.RecentAccessHistory[0].TimeStamp | date:'MM/dd/yy h:mm a'}}
                                </a>
                            </mat-cell>
                        </ng-container>

                        <ng-container *ngIf="isStaffMember" matColumnDef="Actions">
                            <mat-header-cell *matHeaderCellDef style="display: flex; flex: 1; min-width:100px; max-width:100px;">
                                <span translate>Actions</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element; let i = index;" style="min-width:100px; max-width:100px;">
                                <tyl-mat-menu id="spActionMenu{{i}}" image="actions.png" [iconWidth]="30">
                                    <button id="editPortfolioDocument{{i}}" mat-menu-item class="menuItem"
                                        (click)="editPortfolioDocumentClick(element)">Edit</button>
                                    <button id="deletePortfolioDocument{{i}}" mat-menu-item class="menuItem"
                                        (click)="deletePortfolioDocumentClick(element)">Delete</button>
                                </tyl-mat-menu>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="columnsToDisplay" id="portfolioDataHeader" class="sticky-header"
                            style="min-width:1265px;">
                        </mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" tabindex="0"
                            style="padding:0px;overflow: hidden; min-width:1265px;" matRipple>
                        </mat-row>

                    </mat-table>
                </div>
            </div>
        </tyl-kendo-pdf-export>

        <div class="flex-footer">
            <tyl-button *ngIf="classFiltered()" image="filter yellow.png" label="Filter"
                (clickEvent)="showFilterClick()">
            </tyl-button>
            <tyl-button *ngIf="!classFiltered()" image="filter.png" label="Filter" (clickEvent)="showFilterClick()">
            </tyl-button>
            <tyl-button *ngIf="isStaffMember" image="add.png" label="Add Entry" (clickEvent)="addClick()"></tyl-button>

            <div style="display:table; margin:0 auto; min-width:100px; height:100%; padding-top:5px;">
                <filter-notification *ngIf="classFiltered() || portfolioSource.isFiltered()"
                    (clearFilter)="clearFilter(true)" style="padding-top:5px;">
                </filter-notification>
            </div>
        </div>
    </div>


    <div *ngIf="showFilter" class="filter-body">

        <div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
            Filter
        </div>

        <div class="flex-content">

            <!-- File Name -->
            <tyl-form-field label="File Name" style="width:250px;">
                <input matInput [ngModel]="portfolioFilter.Name"
                    (ngModelChange)="portfolioFilter.Name = $event; filterChanged();" name="fileName"
                    id="filterFileNameField">
            </tyl-form-field>

            <!-- Description -->
            <tyl-form-field label="Description" style="width:250px;">
                <input matInput [ngModel]="portfolioFilter.Desc"
                    (ngModelChange)="portfolioFilter.Desc = $event; filterChanged();" name="description"
                    id="filterDescriptionField">
            </tyl-form-field>

            <!-- Category -->
            <tyl-form-field label="Category" style="width:250px;">
                <input matInput [ngModel]="portfolioFilter.Category"
                    (ngModelChange)="portfolioFilter.Category = $event; filterChanged();" name="category"
                    id="filterCategoryField">
            </tyl-form-field>

            <!-- AY -->
            <tyl-form-field label="Year" style="width:250px;">
                <input matInput [ngModel]="portfolioFilter.Year"
                    (ngModelChange)="portfolioFilter.Year = $event; filterChanged();" name="AY" id="filterAYField">
            </tyl-form-field>

            <!-- Added -->
            <tyl-datepicker label="From" [value]="portfolioFilter.FromDate"
                (valueChange)="portfolioFilter.FromDate = $event; filterChanged()" name="addedFrom"
                id="filterAddedFromField"></tyl-datepicker>
            <tyl-datepicker label="To" [value]="portfolioFilter.ToDate"
                (valueChange)="portfolioFilter.ToDate = $event; filterChanged()" name="addedTo" id="filterAddedToField">
            </tyl-datepicker>

            <!-- Added By -->
            <tyl-form-field label="Added By" width="250px;">
                <input matInput [ngModel]="portfolioFilter.AddBy"
                    (ngModelChange)="portfolioFilter.AddBy = $event; filterChanged();" name="AddedBy"
                    id="filterAddedByField">
            </tyl-form-field>
        </div>

        <div class="filter-flex-footer">

            <!-- Left Buttons -->
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter(false)"></tyl-button>

            <!-- Right Buttons -->
            <div class="footerRight">
                <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
            </div>
        </div>

    </div>
</div>
